import { theme } from "@tm/utility/global";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import CheckButton from "../CheckButton/CheckButton";
import FormattedText from "../FormattedText/FormattedText";
import ParaTag from "../TextStyles/ParaTag";
import { ConfirmTnc } from "./TncComp.styles";

export interface ITncForm {
  tncs: boolean[];
}

type TncCompProps = {
  tnc: string[];
  link?: {
    title: string;
    url: string;
  };
  error?: {
    message: string;
  };
  handleTncCheckbox: (index: number) => void;
  isLoading?: boolean;
};

const TncComp = forwardRef<HTMLDivElement, TncCompProps>((data, ref) => {
  const { tnc, link, error, handleTncCheckbox, isLoading } = data;
  const {
    control,
    formState: { errors },
  } = useFormContext<ITncForm>();

  const internalRef = useRef<HTMLDivElement>(null);
  useImperativeHandle(ref, () => internalRef.current!);

  const tncError = errors.tncs?.find?.((item) => item?.message);

  return (
    <ConfirmTnc ref={internalRef}>
      {tnc?.map((tncElement, index) => (
        <Controller
          key={index}
          control={control}
          name={`tncs.${index}`}
          rules={{
            required: {
              value: true,
              message: "Please confirm",
            },
          }}
          render={({ field: { value } }) => (
            <CheckButton
              inputId="confirmTnC"
              handleChange={() => {
                handleTncCheckbox?.(index);
              }}
              isChecked={value}
            >
              <p>
                <FormattedText value={tncElement} />
              </p>
            </CheckButton>
          )}
        />
      ))}

      {tncError && (
        <ParaTag margin="0px 0 0 4px" color={theme.redText2} fontSize="xs">
          {error?.message}
        </ParaTag>
      )}
    </ConfirmTnc>
  );
});

TncComp.displayName = "TncComp";

export default TncComp;
